export const SCHEMA_MANAGEMENT_PREVIEW_KEY = 'schema-management-ui';
